import React, { useCallback, useEffect, useMemo, useState } from "react";
import { hoverHandlerContext } from "./context";

interface IHoverHandlerMasterProps {
  className: string;
  children: React.ReactElement;
}

export const HoverHandlerMaster = ({ className, children }: IHoverHandlerMasterProps) => {
  const [parentElement, setParentElement] = useState<HTMLElement | null>(null);

  const handleParentMouseEnter = useCallback(() => {
    parentElement?.classList.add(...className.split(" "));
  }, [parentElement, className]);
  const handleParentMouseLeave = useCallback(() => {
    parentElement?.classList.remove(...className.split(" "));
  }, [parentElement, className]);

  useEffect(() => {
    if (parentElement !== null) {
      parentElement.addEventListener("mouseenter", handleParentMouseEnter);
      parentElement.addEventListener("mouseleave", handleParentMouseLeave);
      return () => {
        parentElement.removeEventListener("mouseenter", handleParentMouseEnter);
        parentElement.removeEventListener("mouseleave", handleParentMouseLeave);
      };
    }
    return undefined;
  }, [parentElement, handleParentMouseEnter, handleParentMouseLeave]);

  const childWithProps = useMemo(() => React.cloneElement(children, { ref: setParentElement }), [children]);

  const value = useMemo(
    () => ({
      handleParentMouseEnter,
      handleParentMouseLeave,
    }),
    [handleParentMouseEnter, handleParentMouseLeave]
  );

  return <hoverHandlerContext.Provider value={value}>{childWithProps}</hoverHandlerContext.Provider>;
};

export { HoverHandler } from "./child";
